import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import './styles.scss'
import { connect } from 'react-redux'
import DefaultLayout from '../../Layout/Default'
import Box from '../../../Shared/Box'
import { Col, Container, Row } from '../../../Shared/Grid'
import Button from '../../../Shared/Form/Button'
import Input from '../../../Shared/Form/Input'
import Loader from '../../../Shared/Loader'
import { adminUserActions } from '../../../../redux/actions/admin/admin-user'
import { withRouter } from 'react-router-dom'

class AdminLoginPage extends Component {

  constructor (props) {
    super(props)

    this.state = {
      username: '',
      password: '',
      loading: false
    }
  }

  componentDidMount () {
    if(this.props.loggingIn === true) {
      this.props.logout()
    }
    this.onAuthenticatedRedirect()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.onAuthenticatedRedirect()
  }

  onAuthenticatedRedirect () {
    if (this.props.loggedIn) {
      this.props.history.push('/admin')
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.isFormOk()) {
      return
    }
    this.props.login(this.state.username, this.state.password)
  }

  isFormOk () {
    return !(!this.state.username || !this.state.password)
  }

  onUsernameChange = (event) => {
    this.setState({ username: event.target.value })
  }

  onPasswordChange = (event) => {
    this.setState({ password: event.target.value })
  }

  render () {
    const { t } = this.props
    return (
      <DefaultLayout>
        <div className="adminLoginPage">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            {this.props.loggingIn ? <Loader size={40}/> : null}
            <Container fluid gutterWidth={5}>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Row>
                  <Col xs={12}>
                    <h3>{t('LOGIN')}</h3>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Input value={this.state.username} label={t('USERNAME')}
                           onChange={this.onUsernameChange}/>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Input value={this.state.password} label={t('PASSWORD')}
                           type={'password'} onChange={this.onPasswordChange}/>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button
                      disabled={!this.isFormOk()}
                      type={'submit'}
                      align="right"
                      onClick={this.handleSubmit}>{t('LOGIN')}</Button>
                  </Col>
                </Row>
              </form>
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.adminUser.loggedIn,
    loggingIn: !!state.adminUser.loggingIn
  }
}


const mapDispatchToProps = {
  login: adminUserActions.login,
  logout: adminUserActions.logout
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AdminLoginPage)))
